import { useEffect, useState } from "react";

// 🔥 mantém o evento vivo entre páginas
let deferredPromptGlobal = null;

export default function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // 👇 se já tiver salvo, reaproveita
    if (deferredPromptGlobal) {
      setDeferredPrompt(deferredPromptGlobal);
    }

    const handler = (e) => {
      e.preventDefault();
      deferredPromptGlobal = e;
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const installApp = async () => {
    if (!deferredPromptGlobal) return;

    deferredPromptGlobal.prompt();
    const choice = await deferredPromptGlobal.userChoice;

    if (choice.outcome === "accepted") {
      console.log("App instalado");
      deferredPromptGlobal = null;
      setDeferredPrompt(null);
    }
  };

  return {
    installApp,
    canInstall: !!deferredPrompt,
  };
}